import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dismissible_alert = _resolveComponent("dismissible-alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isSucceed)
          ? (_openBlock(), _createBlock(_component_dismissible_alert, {
              key: 0,
              color: "success",
              message: _ctx.successMessage,
              onDismiss: _ctx.dismiss
            }, null, 8, ["message", "onDismiss"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_dismissible_alert, {
      color: "danger",
      message: _ctx.errorMessage,
      onDismiss: _ctx.dismiss
    }, null, 8, ["message", "onDismiss"])
  ]))
}